// Layout.js
import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

function Layout({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('expiration');
    window.location.href = '/login';
  };

  const contentStyle = {
    // Keep your left padding so content clears the sidebar
    paddingLeft: '17.5%',
    paddingTop: '1rem',
    backgroundColor: '#0F172A',
    // Remove or comment out minHeight to fix unwanted scrolling:
    // minHeight: '100vh',
  };

  return (
    <div className="bg-[#0F172A] min-h-screen flex">
      <Sidebar />

      <div className="flex flex-col w-full">
        <TopBar
          fullname={user?.fullname || 'User'}
          onLogout={handleLogout}
        />

        {/* Keep your old approach with left padding */}
        <div className="flex-grow overflow-auto" style={contentStyle}>
          {children}
        </div>
      </div>
    </div>
  );
}

export default Layout;